import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { Contact, ContactNotificationType } from '../../../models';
import { CommonLabelAndValueList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';

const getNotificationOptionLabel = (contact: Contact) => {
  if (contact.contactNotificationTypeId === ContactNotificationType.AllNotifications) return 'All notifications';
  if (contact.contactNotificationTypeId === ContactNotificationType.OnlyWinnerFinalistNotification) return 'Only winner/finalist notification';
  return '';
};

const AdditionalContactSectionImpl: React.FC = () => {
  const { 
    reviewAndSubmitNominationPageUiStore,
  } = useStores();

  return (
    <FlexBox
      wrap
      isFullWidth
      as='section'
      className='nomination-section'
    >
      <Text
        as='h3'
        block
        weight='semibold'
        size={400}
      >
        Additional contact
      </Text>
      {
        reviewAndSubmitNominationPageUiStore.currentNomination?.contacts.map((contact) => (
          <FlexBox
            key={contact.contactId}
            isFullWidth
            direction='column'
            className='nomination-section__list'
          >
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Prefix:'
                childrenFallback={contact.prefix}
              />
              <CommonLabelAndValueList
                label='First name:'
                childrenFallback={contact.firstName}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Last name:'
                childrenFallback={contact.lastName}
              />
              <CommonLabelAndValueList
                label='Contact email:'
                childrenFallback={contact.emailAddress}
              />
            </FlexBox>
            <FlexBox
              isFullWidth
              aligns='start'
            >
              <CommonLabelAndValueList
                label='Notification options:'
                childrenFallback={getNotificationOptionLabel(contact)}
              />
            </FlexBox>
          </FlexBox>
        ))
      }
    </FlexBox>
  );
}

export const AdditionalContactSection = observer(AdditionalContactSectionImpl);
